import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";

const styles = (theme) => {
	return {
		root: {
			width: "180px",
			height: "440px",
			backgroundColor: theme.palette.colors.white,
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.cloudyBlue}`,
			marginRight: "20px",
			marginBottom: "20px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			padding: "30px 30px 50px",
			position: "relative",
		},
		speedWrapper: {
			marginBottom: "46px",
			textAlign: "center",
		},
		speed: {
			fontFamily: theme.fonts.medium,
			fontSize: "64px",
			lineHeight: "0.78",
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "10px",
		},
		speedComment: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: 0.71,
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
		},
		speedWrapperInKbit: {
			"& $speed": {
				color: theme.palette.colors.cloudyBlue,
			},
		},
		limits: {
			textAlign: "center",
			lineHeight: 0,
			marginBottom: "42px",
		},
		limitsValue: {
			marginBottom: "15px",
			"& span": {
				fontSize: "62px",
				color: theme.palette.colors.darkSlateBlue,
				display: "block",
				marginTop: "-17px",
				marginBottom: "-15px",
			},
			"& div": {
				fontFamily: theme.fonts.bold,
				fontSize: "36px",
				lineHeight: "0.83",
				color: theme.palette.colors.darkSlateBlue,
			},
		},
		limitsComment: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			lineHeight: "0.71",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			textTransform: "uppercase",
		},
		typeWrapper: {},
		type: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		typeLogo: {
			marginRight: "9px",
			"& span": {
				fontSize: "24px",
				color: theme.palette.colors.purplishBlue,
			},
		},
		typeName: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: "0.71",
			color: theme.palette.colors.charcoalGrey,
			textTransform: "uppercase",
		},
		date: {
			marginTop: "7px",
			fontFamily: theme.fonts.light,
			fontSize: "14px",
			lineHeight: "1.14",
			textAlign: "center",
			color: theme.palette.colors.oneMoreGrey,
			width: "120px",
		},
		priceWrapper: {
			marginTop: "auto",
			marginBottom: "20px",
		},
		oldPriceWrapper: {
			display: "inline-flex",
			alignItems: "flex-start",
			marginBottom: "5px",
			position: "relative",
			"& div": {
				fontFamily: theme.fonts.medium,
				fontSize: "14px",
				lineHeight: 1,
				letterSpacing: "2px",
				color: theme.palette.colors.coralPink,
				textTransform: "uppercase",
				"&:first-child": {
					marginRight: "5px",
				},
			},
			"&:after": {
				content: "''",
				position: "absolute",
				width: "100%",
				height: "1px",
				backgroundColor: theme.palette.colors.coralPink,
				left: 0,
				top: "5px",
			},
		},
		oldPriceWrapperIsNew: {
			"& div": {
				color: theme.palette.colors.positiveBodyReview,
			},
			"&:after": {
				display: "none",
			},
		},
		mainPriceWrapper: {
			display: "flex",
			alignItems: "flex-start",
			"& div:first-child, span": {
				fontFamily: theme.fonts.bold,
				fontSize: "24px",
				lineHeight: 1,
				color: theme.palette.colors.darkSlateBlue,
				marginRight: "4px",
			},
			"& div:last-child": {
				fontFamily: theme.fonts.medium,
				fontSize: "14px",
				lineHeight: 1,
				letterSpacing: "2px",
				color: theme.palette.colors.oneMoreGrey,
				position: "relative",
				textTransform: "uppercase",
				marginTop: "2px",
				"&:after": {
					content: "''",
					width: "7px",
					height: "1px",
					position: "absolute",
					backgroundColor: theme.palette.colors.oneMoreGrey,
					top: "9px",
					left: "-1px",
				},
			},
		},
		mainPriceWrapperMobile: {},
		mainPriceWrapperMobileNew: {},
		button: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: "100%",
			height: "50px",
			borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			borderRadius: "0 0 10px 10px",
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: 1.14,
			letterSpacing: "2px",
			color: theme.palette.colors.purplishBlue,
			textTransform: "uppercase",
			position: "absolute",
			left: 0,
			right: 0,
			bottom: 0,
			cursor: "pointer",
		},
		withoutButtons: {
			padding: "30px 30px 10px",
			"& $type": {
				flexWrap: "wrap",
			},
			"& $typeLogo": {
				marginRight: 0,
				marginBottom: "15px",
			},
			"& $typeName": {
				width: "100%",
				textAlign: "center",
			},
			"& $date": {
				marginTop: "23px",
				marginLeft: "auto",
				marginRight: "auto",
			},
			"& $priceWrapper": {
				marginTop: "auto",
				marginBottom: "20px",
			},
			"& $mainPriceWrapper": {
				flexWrap: "wrap",
				textAlign: "center",
				justifyContent: "center",
				"& div:first-child": {
					marginRight: 0,
					width: "100%",
					marginBottom: "8px",
				},
			},
			"& $button": {
				display: "none",
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				width: "220px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				width: "170px",
				marginRight: "10px",
				marginBottom: "10px",
				padding: "20px 20px 50px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				width: "100%",
				height: "auto",
				marginRight: 0,
				marginBottom: "10px",
				flexDirection: "row",
				flexWrap: "wrap",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "20px 8.33% 50px",
				"&:last-child": {
					marginBottom: 0,
				},
			},
			speedWrapper: {
				marginBottom: 0,
				textAlign: "left",
				maxWidth: "30%",
				display: "flex",
				flexWrap: "wrap",
				alignItems: "flex-start",
				justifyContent: "center",
				order: 1,
			},
			speed: {
				fontSize: "18px",
				marginRight: "8px",
				marginBottom: "3px",
			},
			speedComment: {
				fontSize: "12px",
				lineHeight: 0.83,
				marginTop: "4px",
			},
			limits: {
				marginBottom: 0,
				display: "flex",
				flexWrap: "wrap",
				alignItems: "center",
				justifyContent: "center",
				order: 2,
				maxWidth: "35%",
			},
			limitsValue: {
				marginBottom: "3px",
				marginRight: "8px",
				"& span": {
					fontSize: "26px",
					marginTop: "-4px",
					marginBottom: "8px",
					height: "14px",
				},
				"& div": {
					fontSize: "18px",
					lineHeight: 0.78,
				},
			},
			limitsComment: {
				fontSize: "12px",
				lineHeight: 0.83,
				marginTop: 0,
			},
			typeWrapper: {
				order: 5,
				width: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				marginTop: "30px",
				marginBottom: "22px",
			},
			date: {
				marginTop: 0,
				fontSize: "12px",
				lineHeight: 1.17,
				textAlign: "center",
				color: theme.palette.colors.oneMoreGrey,
				width: "auto",
			},
			priceWrapper: {
				marginTop: 0,
				order: 3,
				marginBottom: 0,
				width: "30%",
			},
			oldPriceWrapper: {
				display: "none",
			},
			oldPriceWrapperIsNew: {
				display: "none",
			},
			mainPriceWrapper: {
				flexWrap: "wrap",
				justifyContent: "center",
				"& div:first-child, span": {
					fontSize: "18px",
					lineHeight: 0.78,
					marginBottom: "3px",
				},
				"& div:last-child": {
					fontSize: "12px",
					lineHeight: 0.83,
					marginTop: "4px",
					"&:after": {
						top: "6px",
					},
				},
				"& span": {
					wordBreak: "break-all",
				},
				"& $mainPriceWrapperMobile": {
					fontFamily: theme.fonts.medium,
					fontSize: "12px",
					lineHeight: 0.83,
					color: theme.palette.colors.coralPink,
					textDecoration: "line-through",
					marginRight: "2px",
					order: -1,
				},
				"& $mainPriceWrapperMobileNew": {
					color: theme.palette.colors.positiveBodyReview,
					textDecoration: "none",
				},
			},
			mainPriceWrapperMobile: {},
			mainPriceWrapperMobileNew: {},
			button: {
				fontSize: "12px",
			},
			withoutButtons: {
				paddingBottom: 0,
				"& $date": {
					marginTop: "10px",
				},
				"& $button": {
					display: "none",
				},
			},
		},
	};
};

@inject("ApplicationModel")
@observer
class PlansB2B extends React.Component {
	constructor(props) {
		super(props);
	}

	generateType(type) {
		let svg, name;
		let classes = this.props.classes;
		let text = this.props.text;
		switch (type) {
			case 0:
				svg = <span className="icon24 icon-antena-1" />;
				name = "LTE";
				break;
			case 1:
				svg = <span className="icon24 icon-s-arrow-1" />;
				name = "ETHERNET";
				break;
			case 2:
				svg = <span className="icon24 icon-call-hold" />;
				name = "ADSL";
				break;
			case 3:
				svg = <span className="icon24 icon-soundwave" />;
				name = "RADIO";
				break;
			case 4:
				svg = <span className="icon24 icon-call-hold" />;
				name = "ADSL2+";
				break;
			case 5:
				svg = <span className="icon24 icon-flash-4" />;
				name = text.TECH_OPTICAL;
				break;
		}

		return (
			<div className={classes.type}>
				<div className={classes.typeLogo}>{svg}</div>
				<div className={classes.typeName}>{name}</div>
			</div>
		);
	}

	render() {
		let data = this.props.data;
		let classes = this.props.classes;
		let text = this.props.text;
		let windowSizesModel = this.props.ApplicationModel.windowSizeModel;
		return (
			<div
				className={classNames(classes.root, {
					[classes.withoutButtons]: data.withoutButton,
				})}
			>
				<div
					className={classNames(classes.speedWrapper, {
						[classes.speedWrapperInKbit]: data.kbit,
					})}
				>
					<div className={classes.speed}>{data.speed}</div>
					<div className={classes.speedComment}>
						{data.kbit ? text.KBIT : text.MB}/
						{!windowSizesModel.windowSizes.xs ? text.SEC : text.SEC_SHORT}
					</div>
				</div>
				<div className={classes.limits}>
					<div className={classes.limitsValue}>
						{!data.limit && <span className="icon24 icon-infinite" />}
						{!!data.limit && <div>{data.limit}</div>}
					</div>
					<div className={classes.limitsComment}>
						{!data.limit
							? text.UNLIMIT
							: !windowSizesModel.windowSizes.xs
								? `${text.GB} ${text.LIMIT}`
								: text.LIMIT}
					</div>
				</div>
				<div className={classes.typeWrapper}>
					{this.generateType(data.type)}
					<div className={classes.date}>{data.text}</div>
				</div>
				<div className={classes.priceWrapper}>
					{data.price.old && (
						<div className={classes.oldPriceWrapper}>
							<div>{data.price.old}</div>
							<div>{text.SUBSCRIPTION_FEE_TITLE}</div>
						</div>
					)}
					{data.price.sale && (
						<div className={classNames(classes.oldPriceWrapper, classes.oldPriceWrapperIsNew)}>
							<div>{data.price.sale}</div>
							<div>{text.SUBSCRIPTION_FEE_TITLE_}</div>
						</div>
					)}
					{!!data.price.price && (
						<div className={classes.mainPriceWrapper}>
							<div>{data.price.price}</div>
							{windowSizesModel.windowSizes.xs && (data.price.sale || data.price.old) && (
								<span
									className={classNames(classes.mainPriceWrapperMobile, {
										[classes.mainPriceWrapperMobileNew]: data.price.sale,
									})}
								>
									{" "}
									{data.price.sale || data.price.old}
								</span>
							)}
							<div>{text.SUBSCRIPTION_FEE_TITLE}</div>
						</div>
					)}
					{!data.price.price && (
						<div className={classes.mainPriceWrapper}>
							<span>{text.servicesFree}</span>
						</div>
					)}
				</div>
				<Link to={this.props.orderToOfficeUrl} className={classes.button}>
					{text.CONNECT}
				</Link>
			</div>
		);
	}
}

export default withStyles(styles)(PlansB2B);
